(() => {
  function insertCustomCollectionFilters() {
    const source = document.getElementById("gf-custom-filters-source");
    if (!source) return;

    const blocks = Array.from(source.querySelectorAll(".gf-custom-option-block"));
    if (blocks.length === 0) return;

    const target =
      document.querySelector("#gf-tree .gf-filter-contents") ||
      document.querySelector("#gf-tree") ||
      document.querySelector(".gf-filter-contents");

    if (!target) return;
    if (target.querySelector(".gf-custom-option-block")) {
      source.remove();
      return;
    }

    // Prefer inserting inside gf-filter-contents when available.
    const insertionPoint =
      target.matches(".gf-filter-contents") ? target : target.querySelector(".gf-filter-contents") || target;

    // Prepend in original order.
    for (let i = blocks.length - 1; i >= 0; i -= 1) {
      insertionPoint.insertBefore(blocks[i], insertionPoint.firstChild);
    }

    source.remove();
  }

  document.addEventListener("DOMContentLoaded", insertCustomCollectionFilters);
  window.addEventListener("globoFilterRenderCompleted", insertCustomCollectionFilters);
})();

